export const UserManagementTypes = {
    GET_ALL_USER_TYPES:'GET_ALL_USER_TYPES',
}